"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeesLocationChartBody = EmployeesLocationChartBody;
exports.default = EmployeesLocationChartCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const react_i18next_1 = require("react-i18next");
const cancelable_promise_1 = require("cancelable-promise");
const Employees_1 = __importDefault(require("../api/Employees"));
const Loading_1 = __importDefault(require("../components/Loading"));
const GiftedCharts_1 = __importDefault(require("../shared/GiftedCharts"));
const Helper_1 = require("../Helper");
const Button_1 = __importDefault(require("../components/Button"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const ChartLegendItem_1 = __importStar(require("./ChartLegendItem"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
function EmployeesLocationChartBody(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const ChartColors = (0, Theme_1.useChartColors)();
    const PieChart = GiftedCharts_1.default.PieChart;
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [locationPieData] = react_1.default.useState([]);
    const [consolidatedLocData, setConsolidatedLocData] = react_1.default.useState([]);
    const [remoteLocations, setRemoteLocations] = react_1.default.useState([]);
    const [otherLocations, setOtherLocations] = react_1.default.useState([]);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => Employees_1.default.getEmployeeLocations(token)))
            .then((r) => {
            let colorIndex = 0;
            let overflow = { text: t('myBenefits:text.other'), value: 0, color: ChartColors[10] };
            let useOverflow = false;
            // Consolidate all "remote" locations
            let tempData = [];
            let remoteConsolidation = {
                name: t('employees:text.remote'),
                eeCount: 0
            };
            r.forEach(location => {
                if (location.name.toLowerCase().includes('remote') || location.code.toLowerCase().includes('remote')) {
                    remoteConsolidation.eeCount += location.eeCount;
                    remoteLocations.push({
                        text: location.name,
                        subText: location.code,
                        value: location.eeCount
                    });
                }
                else {
                    tempData.push(location);
                }
            });
            if (remoteConsolidation.eeCount > 0)
                tempData.push(remoteConsolidation);
            // Now construct the data array for the pie chart
            tempData.sort((a, b) => (a?.eeCount > b?.eeCount ? -1 : 1));
            tempData.forEach(location => {
                location.name = Helper_1.Helper.FormatTitleCase(location.name);
                if (location.eeCount > 0) {
                    // If we exceed ten locations, consolidate the rest into "other"
                    if (colorIndex > 9) {
                        overflow.value += location.eeCount;
                        useOverflow = true;
                        otherLocations.push({
                            text: location.name,
                            subText: location.code,
                            value: location.eeCount
                        });
                    }
                    else {
                        locationPieData.push({
                            value: location.eeCount,
                            text: location.name + ',' + location.code,
                            color: ChartColors[colorIndex]
                        });
                        consolidatedLocData.push(location);
                        ++colorIndex;
                    }
                }
            });
            consolidatedLocData.sort((a, b) => (a?.eeCount > b?.eeCount ? -1 : 1));
            if (useOverflow) {
                locationPieData.push(overflow);
                consolidatedLocData.push({ name: t('myBenefits:text.other'), eeCount: overflow.value });
            }
            setStatus('done');
        })
            .catch(() => {
            setStatus('error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (status == 'done' && ((0, jsx_runtime_1.jsxs)(FadeInView_1.default, { style: { flex: 1, margin: 12, alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(PieChart, { data: locationPieData, donut: true, innerRadius: size != 'sm' ? 65 : 56, radius: size != 'sm' ? 105 : 90, innerCircleColor: THEME.CardBackground }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                        flex: 1,
                        width: '100%',
                        marginTop: 18
                    }, children: [(0, jsx_runtime_1.jsx)(TableHeader_1.default, { style: { marginBottom: 6, width: '100%' }, columns: [
                                { flex: 2, label: t('employees:labels.location'), align: 'flex-start', indent: 30 },
                                { flex: 1, label: t('employees:text.employees'), align: 'center', indent: 4 },
                                { flex: 1, label: '', align: 'flex-end' }
                            ] }), consolidatedLocData.map((item, index) => (item.eeCount != 0 && (item.name == t('employees:text.remote') ?
                            (0, jsx_runtime_1.jsx)(ChartLegendItem_1.ExpandableChartLegendItem, { ariaLabel: t('employees:hints.locationDetails'), item: { text: item.name, value: item.eeCount, color: locationPieData[index].color }, subText: item.code, expansionItems: remoteLocations, onPress: (subItem) => props.navigation.navigate('LocationDetails', { code: subItem.subText, title: t('employees:labels.location') }) }, index)
                            : item.name == t('myBenefits:text.other') ?
                                (0, jsx_runtime_1.jsx)(ChartLegendItem_1.ExpandableChartLegendItem, { ariaLabel: t('employees:hints.locationDetails'), item: { text: item.name, value: item.eeCount, color: locationPieData[index].color }, subText: item.code, expansionItems: otherLocations, onPress: (subItem) => props.navigation.navigate('LocationDetails', { code: subItem.subText, title: t('employees:labels.location') }) }, index)
                                :
                                    (0, jsx_runtime_1.jsx)(ChartLegendItem_1.default, { ariaLabel: t('employees:hints.locationDetails'), item: { text: item.name, value: item.eeCount, color: locationPieData[index].color }, onPress: () => props.navigation.navigate('LocationDetails', { code: item.code, title: t('employees:labels.location') }), pressable: true, subText: item.code }, index))))] })] }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }) }));
}
function EmployeesLocationChartCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('employees:text.employeeLocs'), style: { marginBottom: 8 }, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { type: 'outline', accessibilityHint: t('employees:hints.locationAdd'), onPress: () => props.navigation.navigate('AddLocation'), children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: '500', marginHorizontal: 6 }, children: t('common:buttons.add') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.Plus, size: 14, style: { marginRight: 6 } })] }) }), (0, jsx_runtime_1.jsx)(EmployeesLocationChartBody, { navigation: props.navigation })] }));
}
;
